import { createAsyncThunk } from "@reduxjs/toolkit"
import { GenericRejectionResponseWithReason } from "integrations/redux/types"
import { selectActivatedFireId } from "features/map/control/selectors"
import { BoundingBox } from "@nova/constants"
import { activateHotspotPointLayerAction } from "../flights/slice"
import { zoomToShowPoints } from "features/map/zoom/thunks"
import { RootState } from "integrations/redux/rootReducer"
import { selectActiveWorkspaceId } from "features/data-management/workspace/WorkspaceManagementSlice"

export const uploadHotspotKml = createAsyncThunk<
    void,
    { kml: File; flightId: string },
    GenericRejectionResponseWithReason
>("entities/hotspots/uploadKml", async (payload, thunkApi) => {
    const { kml, flightId } = payload
    const state = thunkApi.getState() as RootState
    const workspaceId = selectActiveWorkspaceId()(state) || ""
    const projectId = selectActivatedFireId(state) || ""
    const dispatch = thunkApi.dispatch

    try {
        const res = await fetch(
            `/api/protobuf/org/${workspaceId}/project/${projectId}/infraredJob/${flightId}/createManual`,
            {
                method: "POST",
                body: await kml.text(),
                headers: { region: sessionStorage.getItem("region") || "" },
            }
        )
        const { bbox } = (await res.json()) as { bbox: BoundingBox }
        if (
            Object.values(bbox).some(
                (bboxVal) =>
                    bboxVal === null || (Array.isArray(bboxVal) && bboxVal.some((b) => b === null))
            )
        ) {
            return thunkApi.rejectWithValue(false, {
                rejectionReason: "Couldn't find hotspots in KML",
            })
        }
        dispatch(activateHotspotPointLayerAction({ id: flightId }))
        dispatch(
            zoomToShowPoints({
                points: [bbox.topLeft, bbox.topRight, bbox.bottomLeft, bbox.bottomRight],
            })
        )
    } catch (err) {
        console.error(err)
        return thunkApi.rejectWithValue(false, { rejectionReason: "Request failed" })
    }
})
